// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ktMq","type":"styles_type__3VoGP","choices":"styles_choices__n_tfT"};